import { render } from "./HighFreqBomber.vue?vue&type=template&id=acb5190e&scoped=true"
import script from "./HighFreqBomber.vue?vue&type=script&lang=js"
export * from "./HighFreqBomber.vue?vue&type=script&lang=js"

import "./HighFreqBomber.vue?vue&type=style&index=0&id=acb5190e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb5190e"]])

export default __exports__